import React from 'react';
import { Heading, Text } from '@chakra-ui/react';

const Bottombar = (props) => {
  return (
    <></>
  );
};

export default Bottombar;